<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.05 0C2.4701 0 2 0.4701 2 1.05V10.95C2 11.5299 2.4701 12 3.05 12C3.6299 12 4.1 11.5299 4.1 10.95V1.05C4.1 0.470101 3.6299 0 3.05 0ZM8.95039 0C8.37049 0 7.90039 0.4701 7.90039 1.05V10.95C7.90039 11.5299 8.37049 12 8.95039 12C9.53029 12 10.0004 11.5299 10.0004 10.95V1.05C10.0004 0.470101 9.53029 0 8.95039 0Z"
    fill="currentColor"
  />
</template>
